export enum CONFIG_NAME {
  ARGENTINA = "argentina",
  CHILE_CORPORATE = "chile_corporate",
  CHILE = "chile",
  OTROS = "otros",
  PERU = "peru",
  BASE = "base",
}
